"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgNoInternet = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-2A8 8 0 0 1 5.68 7.094l1.488 1.489a9.555 9.555 0 0 0-.837.674 1 1 0 1 0 1.338 1.486c.3-.27.614-.512.939-.721l1.338 1.338c-.551.2-1.071.483-1.547.84a1 1 0 1 0 1.202 1.6 3.946 3.946 0 0 1 2.003-.782l5.302 5.302A7.965 7.965 0 0 1 12 20Zm6.32-3.094A8 8 0 0 0 7.094 5.68l1.899 1.898A8.025 8.025 0 0 1 11.987 7c2.076 0 4.07.812 5.68 2.255a1 1 0 1 1-1.334 1.49C15.078 9.62 13.555 9 11.987 9c-.478 0-.948.056-1.406.166l1.85 1.85c1.152.084 2.252.5 3.167 1.183a1 1 0 0 1-.247 1.738l2.969 2.969ZM12 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgNoInternet);
//# sourceMappingURL=SvgNoInternet.js.map